import { Grid, Box, Flex, Text, Collapse } from '@chakra-ui/react'
import { FC, useMemo, useEffect } from 'react'
// import { Offline, Online } from 'react-detect-offline'

import useFollowUpOtb from '@hook/Otb/use-followUp'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import LayoutTools from '@component/Layout/Tools'
import OtbFollowUpGraphic from '@component/Modules/Otb/Graphics/FollowUpGraphic'
import OpenOrCloseChartButton from '@component/Modules/Otb/Graphics/OpenOrCloseButton'

import { disableActionsByDefault } from '@helper/alert/disableActionsByDefault'
import { scalesHeightKpiTable } from '@helper/otb/followUp/scalesHeightKpiTable'
import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const FollowUpOtb: FC = () => {
  const { hasSessions } = useSessions()
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    actions,
    data,
    filename,
    params,
    filters,
    setFilters,
    getData,
    pagination,
    handlePageChange,
    dataFooter,
    filtersList,
    handleUpdateParams,
    isGraphic,
    graphicValues,
    setQuery,
    query,
    loadingGraphic,
    isShowContentChart,
    setIsGraphic,
    updateIsGraphic,
    handleLocalParams,
    clearAllFilters
  } = useFollowUpOtb()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () => scalesHeightKpiTable({ menuToggle, isGraphic, hasSessions }),
    [menuToggle, isGraphic, hasSessions]
  )

  useEffect(() => {
    // handleLocalParams()
    // data?.length === 0 && getData()
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          handleLocalParams()

          getFilters({
            periods: true,
            companies: true,
            centers: true,
            compactCategories: true,
            categories: true,
            categoryManagers: true,
            productManagers: true,
            providersForDistribution: true,
            worlds: true
          })
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Alertas de Compra">
      {/* <div>
        <Online>Only shown when you re online</Online>
        <Offline>Only shown offline (surprise!)</Offline>
      </div> */}
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={loading}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            onSearchChange={setQuery}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || data.length === 0}
            disableActionsByDefault={disableActionsByDefault}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <Flex
                justifyContent="space-between"
                alignItems="center"
                paddingRight={4}
                paddingLeft={3}
                paddingY={1}
              >
                <Text fontSize={14}>
                  Quantidade de Registros: {pagination.totalRows}
                </Text>

                {isShowContentChart &&
                  graphicValues.desvioMedio?.length > 0 && (
                    <OpenOrCloseChartButton
                      openText="Abrir gráfico"
                      closeText="Fechar gráfico"
                      graphicValue={graphicValues.desvioMedio}
                      isGraphic={isGraphic}
                      setIsGraphic={setIsGraphic}
                    />
                  )}
              </Flex>

              {isShowContentChart && (
                <Collapse
                  in={
                    loadingGraphic ||
                    (!loadingGraphic &&
                      graphicValues.desvioMedio?.length > 0 &&
                      isGraphic)
                  }
                  unmountOnExit={true}
                >
                  {loadingGraphic ? (
                    <LayoutLoader
                      type="logistic"
                      title="Recuperando informações..."
                      message="Aguarde enquanto buscamos os registros no banco de dados"
                    />
                  ) : graphicValues.desvioMedio?.length === 0 ? (
                    <LayoutEmpty
                      type="logistic"
                      title="Nada encontrado!"
                      message="Filtre sua busca ao lado para obter informações"
                    />
                  ) : (
                    isGraphic && (
                      <>
                        <OtbFollowUpGraphic data={graphicValues} />
                        <Box
                          paddingBottom={3.5}
                          boxShadow="inset 0px 1px 5px 2px #dcdcdc"
                        />
                      </>
                    )
                  )}
                </Collapse>
              )}

              <TableGrid
                id="otb-follow-up"
                headers={headers}
                data={data}
                height={tableHeight}
                query={query}
                itsSortable={true}
                entity="otb-followUp"
                pagination={pagination}
                dataFooter={dataFooter}
                isFooter={true}
                updateIsGraphic={updateIsGraphic}
                udatePageChange={handlePageChange}
                isPagedBack={true}
                isPaged={false}
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default FollowUpOtb
